import { render } from "./posturalFormulario.vue?vue&type=template&id=3499ef86&scoped=true"
import script from "./posturalFormulario.vue?vue&type=script&lang=js"
export * from "./posturalFormulario.vue?vue&type=script&lang=js"

import "./posturalFormulario.vue?vue&type=style&index=0&id=3499ef86&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3499ef86"]])

export default __exports__